
      <app-form-button class="medium no-width balance-btn" (click)="balanceDropdown = !balanceDropdown">
        <div class="balance-current">
          <img src="/assets/images/currency/{{ balance.getCurrency().toString().toLowerCase() }}.svg"
               height="25" alt="" class="balance-chip">
          <div class="balance-amount">
            {{ balance.getCurrentBalance() | crypto : balance.getCurrency() : 'code' : true : true }}
          </div>
        </div>
        <div class="nav-link-drop"><i class="fal fa-chevron-down"></i></div>
      </app-form-button>
    <div class="balance-dropdown" *ngIf="balanceDropdown" [@dropdown]="'show'">
      <div class="triangle"></div>

      <div>
         <span *ngFor="let item of currencyList" (click)="changeCurrency(item)" class="currency-select-item">
              <img src="/assets/images/currency/{{ item }}.svg"
                   height="25"
                   alt="{{ item }}"
                   class="balance-chip-2">
              <span class="nav-balance">
                <span>{{ balance.getBalance(item) | crypto: item : 'code' : true }}</span>
                <span class="currency" [ngClass]="item">{{ item.toString().toUpperCase() }}</span>
              </span>
            </span>

        <div class="mt-3"></div>

        <ng-container *ngFor="let tab of tabs">
          <a [routerLink]="tab.url" class="dropdown-link" data-id="header-tab-{{ tab.id }}">
            <div class="icon dark-icon-bg">
              <i class="fal {{tab.icon}}"></i>
            </div>
            <div class="dropdown-link-text">{{tab.title}}</div>
          </a>
        </ng-container>
      </div>

    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/header-navigation/balance-selector.component.ts.BalanceSelectorComponent.html